 import React from 'react'
import { useEffect, useState, useRef, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import { isEmpty, getglobaldata, CellType, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata, getformid, getcontroller, getsubkey, NumConv, isEnabled, isNumber } from '../modules/appLibrary';
import { styled } from '@material-ui/core/styles';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption } from '../modules/formstore';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const TerminalOrd = props => {

    const panelsdef = [];
    const formid = getformid("TerminalOrd", props.location.search);
    const controller = getcontroller("TerminalOrd", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const menuinfo = useSelector(state => state.form.menuinfo);

    const fnc = useRef();
    const baseref = useRef();

    //データ
    const entrydataRef = useRef(null);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const ComFunc = React.forwardRef(ComFunction);


    const actionurl = {
        "getlist": "TerminalOrd/GetListData",
    }

    const navmenu = [
        { status: "VIEW", menuid: "print1", icon: "print", label: "ターミナルオーダー出力" },
    ]

    function MenuAction(action, finallycallback, param) {
        if (action === "print1") {      //ターミナルオーダー出力
            let condition = baseref.current.ListCondition();
            let param = { controller: controller, id: action };
            let showtype = false;
            if (!isEmpty(entrydataRef.current)) showtype = entrydataRef.current["ShowType"] === "1" ? true : false;
            param["splitByTarget"] = showtype;
            if (!isEmpty(condition)) {
                for (let i = 0; i < condition.length; i++) {
                    switch (condition[i].columnid) {
                        case "SWT_NO":
                            param.swtNoFrom = condition[i].value;
                            param.swtNoTo = condition[i].value2;
                            break;
                        case "SWT_BRDCD":
                            param.brdCode = condition[i].value;
                            break;
                        case "TOSD_SEASON":
                            param.seasonCode = condition[i].value;
                            break;
                        case "PDT_YEAR":
                            param.year = condition[i].value;
                            break;
                        case "PDT_OPPICD":
                            param.oppiCd = condition[i].value;
                            break;
                    }
                }
            }
            fnc.current.postaxios('TerminalOrderLinkReport/Generate', param,
                {
                    onSuccess: function (data) {
                        let params = {
                            "excelfile": data.returnData["filename"],
                            "dnfile": data.returnData["dnfile"]
                        }
                        fnc.current.filedownload("excel/ExcelDownload", params);
                        fnc.current.wait(false);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
        }
    }


    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                ref={baseref}
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                entrycallback={MenuAction}
                tabs={true}
                navmenu={navmenu}
                entrydataRef={entrydataRef}
                usecondition={true}
           >
            </MasterBase>
        </div>
    );
};


